const getToggleAndExperimentValue = (togglesAndExperiments, enums) => {
    return Object.entries(enums).reduce((acc, [experimentName, id]) => {
        const toggle = togglesAndExperiments.find((toggle) => toggle.id === id);
        if (toggle) {
            acc[experimentName] = toggle.value === 'true';
        }
        return acc;
    }, {});
};

export { getToggleAndExperimentValue };
//# sourceMappingURL=toggle-and-experiments.js.map
